import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next"

const ContactButton = () => {
  const [showContact, setShowContact] = useState(false);
  const { t } = useTranslation();
  const [isWorkingHours, setIsWorkingHours] = useState(false);

  useEffect(() => {
    const checkWorkingHours = () => {
      const now = new Date();
      const day = now.getDay();
      const hour = now.getHours();
      const minute = now.getMinutes();

      const isWeekday = day >= 1 && day <= 5;
      const isWithinHours = (
        (hour > 9 && hour < 18) ||
        (hour === 9 && minute >= 0) ||
        (hour === 18 && minute === 0)
      );
      
      setIsWorkingHours(isWeekday && isWithinHours);
    };
    checkWorkingHours();
  }, []);

  return (
    <div className="relative">
      <button
        onClick={() => setShowContact(!showContact)}
        className="w-14 h-14 rounded-full bg-[#0c4a93] text-white flex items-center justify-center shadow-lg hover:opacity-90 transition-all duration-300"
        title="Байгууллагатай холбогдох"
      >
        <div className="relative">
          {showContact ? (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
            </svg>
          )}
        
          {!showContact && isWorkingHours && (
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </span>
          )}
        </div>
      </button>

      {showContact && (
        <div className="absolute bottom-16 right-0 bg-white rounded-xl shadow-2xl p-6 min-w-80 border border-gray-100 z-50">
          <div className="flex items-center mb-4 pb-3 border-b border-gray-100">
            <div className="flex-shrink-0 w-10 h-10 bg-[#0c4a93] rounded-full flex items-center justify-center mr-3">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-white">
                <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
              </svg>
            </div>
            <div>
              <h3 className="font-bold text-gray-900 mb-2">{t('contactfiba')}</h3>
            </div>
          </div>
          
          <div className="space-y-4">
            <div className="flex items-start group hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-blue-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                </svg>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('phone')}</p>
                <span className="font-semibold text-gray-700">75092211</span>
              </div>
            </div>
            
            <div className="flex items-start group hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-green-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
                </svg>
              </div>
                <div>
                 <p className="text-sm text-gray-500">{t('email')}</p>
                  <a href="mailto:contact@fiba.mn" className="font-semibold text-gray-700 hover:text-blue-600">
                    contact@fiba.mn
                  </a>
                </div>
            </div>
            
            <div className="flex items-start group hover:bg-gray-50 p-2 rounded-lg transition-colors duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3 mt-0.5">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-purple-600">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5A2.25 2.25 0 015.25 5.25h13.5A2.25 2.25 0 0121 7.5v2.25a.75.75 0 01-.75.75 2.25 2.25 0 000 4.5.75.75 0 01.75.75V16.5a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 16.5v-2.25a.75.75 0 01.75-.75 2.25 2.25 0 000-4.5A.75.75 0 013 9.75V7.5z" />
                </svg>
              </div>
              <div>
                <p className="text-sm text-gray-500">{t('jira')}</p>
                <a 
                  href="https://ticket.fiba.mn" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="font-semibold text-blue-700 hover:text-blue-800 transition-colors duration-200 flex items-center"
                >
                  https://ticket.fiba.mn
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-1">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
           <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-sm text-gray-500 text-center">
                    {t('workhour')}: <br/>
                    {t('mondaytofriday')} 09:00-18:00
                </p>
            </div>
          </div>
      )}
    </div>
  );
};

export default ContactButton;